module.exports = __webpack_public_path__ + "img/catamnesis2.bdfaca54.jpg";